import { cn } from "@omni/utils/styles";
import { useEffect, useRef } from "react";

type Props = {
    link: string;
    title: string;
    idAttribute: string;
    lazyLoading: "eager" | "lazy";
};

const AidenIFrameContainer = ({
    lazyLoading,
    idAttribute,
    title,
    link
}: Props) => {
    const iFrameRef = useRef<HTMLIFrameElement>(null);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        const setScrollOffset = () => {
            if (iFrameRef.current) {
                iFrameRef.current.setAttribute(
                    "data-scrolloffset",
                    (
                        iFrameRef.current.getBoundingClientRect().top * -1
                    ).toString()
                );
            }
        };

        window.addEventListener("resize", setScrollOffset);
        setScrollOffset();

        return () => {
            window.removeEventListener("resize", setScrollOffset);
        };
    }, [iFrameRef.current]);

    return (
        <div>
            <iframe
                ref={iFrameRef}
                src={link}
                title={title}
                id={idAttribute}
                loading={lazyLoading}
                className={cn(
                    "tw:block tw:box-border tw:border-none tw:w-full"
                )}
            ></iframe>
        </div>
    );
};

export { AidenIFrameContainer };
